import axios from "axios";

const chaching = axios.create({
  baseURL: process.env.REACT_APP_CHACHING_API,
});

export { chaching };
